import { gql } from 'graphql.macro';

export const GetObservationCategorisationLookups = gql`

    query {
        nearMissCategories: nearmisscategorylookup {
            id: nearMissCategoryId
            name: nearMissCategoryName
            nameDe: nearMissCategoryNameDE
        }

        nearMissLocationTypes: nearmissenumlookup(request: { type: LOCATIONTYPE }) {
            id
            name: type
            description
        }       
        
        companies: allCompanies {
            companyId
            companyName
            usersCompany
        }
    }
`;

export const GetEnhancements = gql`
    fragment processModel on ObservationProcessResponseModel {
        processId
        processName
        description
        example
    }

    fragment reachModel on ObservationReachResponseModel {
        reachId
        reachName
    }

    query GetNearMissProcessesAndReaches {
        nearMissProcesses {
            ...processModel
        }
        nearMissReaches {
            ...reachModel
        }
    }
`

export const GetServiceCentres = gql`
    query GetServiceCentres($companyId: Int){
        
        depots: allServiceCentre(companyId:$companyId, openDepotsOnly: true) {
            pcId: pCID
            pc: pC
            pcName: pCName
        }        
    }
`;

